import { Variable } from '../interfaces/variable';
import { BaseAuthenticationResource } from './BaseAuthenticationResource';

export class VariableResource extends BaseAuthenticationResource implements Variable {
  variableId = 0;
  name = '';
  query?: string | undefined = '';
  changedBy?: string | undefined = '';
  changedDate?: Date | undefined = undefined;

  pk() {
    return `${this.variableId}`;
  }

  static urlRoot = '/api/variables/';
}
